/**
 * Contributions + Accruals Calculator
 *
 * For JMH Capital (isJMH) - event-based calculation where value equals
 * sum of Contribution events plus sum of Gain (Loss) Accrual events.
 *
 * From index.js lines 6039-6057:
 *   userEvents.forEach(function (e, index) {
 *     let clientEvent = clientEvents.find(obj => obj.nrid == e.nrid);
 *     if (clientEvent) {
 *       if (clientEvent.eventType == "Contribution") sumContributions += Number(e.grossDollars);
 *       else if (clientEvent.eventType == "Gain (Loss) Accrual") sumAccruals += Number(e.grossDollars);
 *     }
 *   });
 *   latestValue[key] = sumContributions + sumAccruals;
 *
 * Data Source: User events matched with client event types
 */

const ContributionsAccrualsCalculator = {
  methodId: 'contributions_accruals',
  displayName: 'Contributions + Accruals',
  requiredDataSources: ['contributions', 'accruals'],

  // Graph configuration - line graph shows cumulative contributions + accruals over time
  graphConfig: {
    recommendedType: 'time_series_line',
    timeSeriesStrategy: 'fund_capital_account',
    supportsTimeSeries: true
  },

  /**
   * Calculate value from contributions plus gain/loss accruals
   * @param {Object} input
   * @param {Object} input.holdings - { contributions, accruals } by class
   * @param {string[]} input.shareClasses - Array of share class keys
   * @returns {Object} CalculationResult
   */
  calculate: function(input) {
    const holdings = input.holdings;
    const shareClasses = input.shareClasses || Object.keys(holdings.contributions || {});

    let totalContributions = 0;
    let totalAccruals = 0;
    const breakdown = [];

    shareClasses.forEach(function(key) {
      const contributions = holdings.contributions[key] || 0;
      const accruals = holdings.accruals[key] || 0;

      // JMH formula: latestValue = sumContributions + sumAccruals
      const value = contributions + accruals;

      totalContributions += contributions;
      totalAccruals += accruals;

      breakdown.push({
        classKey: key,
        className: key,
        value: value,
        contributions: contributions,
        accruals: accruals
      });
    });

    return {
      totalValue: totalContributions + totalAccruals,
      totalContributions: totalContributions,
      totalAccruals: totalAccruals,
      breakdown: breakdown,
      fundMetrics: null,  // JMH uses account statements, not fund metrics
      metadata: {
        methodUsed: this.methodId,
        calculationDate: new Date()
      }
    };
  }
};

export { ContributionsAccrualsCalculator };
